var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"criteria-banner",class:_setup.bannerClasses},[_c('span',{staticClass:"criteria-text"},[_c('strong',{staticClass:"criteria-prefix"},[_vm._v(_vm._s(_vm.criteriaPrefix))]),_vm._v(" "+_vm._s(_vm.criteria))])])
}
var staticRenderFns = []

export { render, staticRenderFns }